module.exports = __webpack_public_path__ + "static/img/12bg_5.d549caa.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_5.png
// module id = 635
// module chunks = 1